import React from "react";
import { usePublicPageSection } from "../../../../hooks/usePublicPageSection";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import { useLanguage } from "../../../../context/LanguageContext";
import "./Hero.css";

const requireField = (fields, key) => {
  const value = fields?.[key];
  if (value == null || String(value).trim() === "") {
    throw new Error(
      `Report submitted hero field "${key}" is missing from the API response.`
    );
  }
  return value;
};

const requireMediaUrl = (section, groupKey) => {
  const item = section.media?.groups?.[groupKey]?.[0] || null;
  if (!item?.url) {
    throw new Error(
      `Report submitted hero media group "${groupKey}" is missing from the API response.`
    );
  }
  return resolveMediaUrl(item.url);
};

const buildModel = (section) => {
  const f = section.fields || {};
  return {
    title: requireField(f, "title"),
    subtitle: requireField(f, "subtitle"),
    secureText: requireField(f, "secureText"),
    checkIcon: requireMediaUrl(section, "check"),
    lockIcon: requireMediaUrl(section, "lock"),
  };
};

const Hero = () => {
  const { meta } = useLanguage();
  const { model, error, isLoading } = usePublicPageSection(
    "report-submitted",
    "hero",
    buildModel
  );

  if (isLoading) {
    return (
      <section className="submitted-hero" dir={meta.dir}>
        <div className="submitted-hero__content">
          <p style={{ color: "#64748b", fontSize: 14 }}>Loading…</p>
        </div>
      </section>
    );
  }

  if (error || !model) {
    return (
      <section className="submitted-hero" dir={meta.dir}>
        <div className="submitted-hero__content">
          <p style={{ color: "#b91c1c", fontSize: 14 }}>
            {error || "Submitted hero unavailable."}
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="submitted-hero" dir={meta.dir}>
      <div className="submitted-hero__content">
        <div className="submitted-hero__icon" aria-hidden="true">
          <span className="submitted-hero__icon-outer">
            <span className="submitted-hero__icon-inner">
              <img
                src={model.checkIcon}
                alt=""
                className="submitted-hero__check"
              />
            </span>
          </span>
        </div>

        <h1 className="submitted-hero__title">{model.title}</h1>

        <p className="submitted-hero__subtitle">{model.subtitle}</p>

        <div className="submitted-hero__secure">
          <img src={model.lockIcon} alt="" aria-hidden="true" />
          <span>{model.secureText}</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
